module.exports = __webpack_public_path__ + "static/img/ic_treatmentClass3.4a5b5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_treatmentClass3.png
// module id = mBiv
// module chunks = 1